
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';

const classPrefix = 'partial-publish';

export namespace PartialPublishDialogStyle {
  export const DialogStyle: React.CSSProperties = {
    padding: '0px 12px 0px'
  };

  export const HeaderStyle: React.CSSProperties = {
    fontSize: '16px',
    fontWeight: 'lighter',
    marginBottom: CommonStyles.Sizes.LargeSpace
  };

  export const FailureListStyle = cssClass(classPrefix, 'failure-list', {
    marginBottom: CommonStyles.Sizes.RowHeight
  });

  export const TextAreaStyle: React.CSSProperties = {
    width: 320,
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    resize: 'none',
    marginLeft: '15px'
  };

  export const IconStyle: React.CSSProperties = {
    verticalAlign: 'middle',
    paddingRight: '5px'
  };
}
